import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get, isNil } from "lodash-es";
import { MeltShopProductionShiftFilter } from "../models/Filters";

export const getShiftByParameters = async (
  parameters: MeltShopProductionShiftFilter,
) => {
  try {
    const sqlParameters = [
      {
        name: "ShiftId",
        value: parameters.shiftId === 0 ? null : parameters.shiftId,
      },
      {
        name: "ProductionDate",
        value: JSON.parse(JSON.stringify(parameters.productionDate)),
      },
    ];
    const apiService = new MESApiService();
    const resp = await apiService.callV2(
      "[MES].[GetShiftByParameters]",
      sqlParameters,
    );
    if (resp.ok) {
      const data = get(resp, "data.tables[0].rows[0]", {});
      if (data.CurrentProductionDate) {
        return {
          ok: true,
          data: data,
        };
      }
      return {
        ok: true,
        data: get(resp, "data.tables[0].rows[0]", {}),
      };
    }
    return resp;
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

//Caster Processes
export const getProcessesByShift = async (
  shiftId: number,
  deleted: boolean,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ShiftId", value: shiftId },
    { name: "GetDeleted", value: deleted },
  ];
  return await apiService.callV2("[CAS].[GetProcessesByShift]", parameters);
};

export const upsertProcess = async (
  processId: number | null,
  start: Date | null,
  end: Date | null,
  isManual: boolean,
  assetId?: number | null,
) => {
  try {
    const apiService = new MESApiService();
    const parameters: spParameter[] = [
      { name: "ProcessId", value: processId },
      {
        name: "Start",
        value: isNil(start) ? null : new Date(start).toISOString(),
      },
      {
        name: "End",
        value: isNil(end) ? null : new Date(end).toISOString(),
      },
      { name: "IsManual", value: isManual },
    ];
    if (assetId) parameters.push({ name: "AssetId", value: assetId || null });
    return await apiService.callV2("[CAS].[UpsertProcess]", parameters);
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

export const deleteProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessId", value: processId }];
  return await apiService.callV2("[CAS].[DeleteProcess]", parameters);
};

export const unDeleteProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessId", value: processId }];
  return await apiService.callV2("[MS].[UndeleteProcess]", parameters);
};

export const upsertProcessData = async (
  processId: number,
  field: string,
  value: any,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: field, value: value },
    { name: "IsManual", value: true },
  ];
  return await apiService.callV2("[CAS].[UpsertProcessData]", parameters);
};

export const linkCasterProcess = async (
  processId: number,
  heatId: number,
  force?: boolean,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "ProcessId", value: processId },
    { name: "HeatId", value: heatId },
    { name: "Force", value: force ?? false },
    { name: "IsHeatIdManual", value: true },
  ];
  return await apiService.callV2("[CAS].[LinkProcessToHeat]", parameters);
};
export const unLinkCasterProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [{ name: "ProcessId", value: processId }];
  return await apiService.callV2("[CAS].[UnlinkProcessToHeat]", parameters);
};

export const searchUnlinkedHeats = async (
  searchText: string,
  ladleOpen: Date,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "SearchText", value: searchText },
    { name: "LadleOpen", value: ladleOpen },
  ];
  return await apiService.callV2(`[CAS].[SearchUnlinkedHeats]`, parameters);
};
